export default __webpack_public_path__ + "static/media/sympton_bg.0fa03898.png";